import { useRouter } from 'next/router'
import {
  useEffect, useCallback, useState, useMemo, useRef
} from 'react'
// import Banner from '@/components/general/banner/Banner'
import { getBrandDetail } from '@/service/brands.api'
import { getProductByBrand, countProductByBrand, getBrandId } from '@/service/product-list.api'
import { addCommas } from '@/utils/formatter'
import styles from '@/styles/brand-detail.module.scss'
import BoxProduct, { ProductSkeleton } from '@/components/box-product/BoxProduct'
import Select from '@/components/general/Select/Select'
import marked from 'marked'
import NoData from '@/components/general/NoData/NoData'
import useInfiniteLoad from '@/hooks/infiniteLoad'

import { getHomeBanner } from '@/service/home.api'
import { MainBanner } from '@/components/general/banner/main/MainBanner'

export async function getServerSideProps(context) {
  const { slug } = context.params
  if (slug) {
    try {
      const [homeResponse, response] = await Promise.all([getHomeBanner(), getBrandDetail(slug)])
      const brand = response.data.brands[0]
      return {
        props: {
          brandId: brand?.id || '',
          brandName: brand?.brandName || '',
          brandImage: brand?.banner?.url || '',
          brandDetail: brand?.detail || '',
          homeData: homeResponse.data.home
        }
      }
    } catch (e) {
      console.log(e)
    }
  }
  return {
    redirect: {
      destination: '/',
      permanent: false
    }
  }
}

export default function BrandDetail({
  brandId, brandName, brandDetail, brandImage, homeData
}) {
  const router = useRouter()
  const watchListRef = useRef()
  const [loading, setLoading] = useState(false)
  const { slug } = router.query
  const [sort, setSort] = useState('relevance')
  const [watches, setWatches] = useState([])
  const limit = 12
  const [currentPage, setCurrentPage] = useState(1)
  const [countAll, setCountAll] = useState(0)
  const currentOffset = useMemo(() => (currentPage - 1) * limit, [currentPage])
  const maxPage = useMemo(() => Math.ceil(countAll / limit), [countAll])

  // const brandIdRequest = useMemo(async () => {
  //   const response = await getBrandId(slug)
  //   return response.data.brands[0].id
  // }, [slug])



  const fetchBrandProduct = useCallback(async () => {
    // const id = await brandIdRequest
    setLoading(true)
    if (brandId) {
      try {
        const response = await getProductByBrand(brandId, currentOffset, limit, sort)
        const { userProducts: list } = response.data
        if (currentOffset === 0) {
          setWatches(list)
        } else {
          setWatches((prev) => [...prev, ...list])
        }
      } catch (error) {

      } finally {
        setLoading(false)
      }
    }
  }, [brandId, currentOffset, sort])

  const fetchBrandProductCount = useCallback(async () => {
    if (brandId) {
      try {
        const response = await countProductByBrand(brandId)
        setCountAll(response.data.userProductsCount)
      } catch (error) {
      }
    }
  }, [brandId])

  const resetPage = () => {
    setWatches([])
    setCurrentPage(1)
  }

  const onSortChanged = (val) => {
    setSort(val)
    resetPage()
  }

  useEffect(() => {
    fetchBrandProductCount()
  }, [fetchBrandProductCount])

  useEffect(() => {
    fetchBrandProduct()
  }, [fetchBrandProduct])

  useEffect(() => {
    if (brandId) {
      resetPage()
    }
  }, [brandId])

  const loadMore = () => {
    if (currentPage < maxPage && !loading) {
      setCurrentPage((prev) => prev + 1)
    }
  }

  useInfiniteLoad(watchListRef, loadMore)
  console.log(homeData)


  return (
    <>
      {
        homeData?.firstBanner && <MainBanner data={homeData.firstBanner.map((item) => ({ ...item, priority: true }))} />
      }
      {/*<Banner src={brandImage} text={brandName} />*/}
      {brandDetail && <div className={styles.detail} dangerouslySetInnerHTML={{ __html: brandDetail || '' }} />}
      <div className="max-width" style={{ marginTop: 24 }}>
        <div className={styles.filterWrap}>
          {watches.length > 0
            && (
            <Select
              style={{ marginLeft: 'auto', maxWidth: 200 }}
              stylingClass={styles.input}
              value={sort}
              onSelect={(item) => onSortChanged(item.value)}
              items={[
                {
                  text: 'Relevance',
                  value: 'relevance'
                },
                {
                  text: 'A-Z',
                  value: 'a-z'
                },
                {
                  text: 'Z-A',
                  value: 'z-a'
                }
              ]}
            />
            )}
        </div>
        <div className={styles.watchList} ref={watchListRef}>
          {
            watches.length === 0 && !loading
            ? <NoData />
            : watches.map((watch, index) => (
                <BoxProduct
                  key={watch.id}
                  title={watch.name}
                  subTitle={watch.model}
                  image={watch.images?.[0].url || ''}
                  category={watch.brand.brandName}
                  price={`฿ ${addCommas(watch.price?.toString() || '0')}`}
                  url={`/product/${watch.id}`}
                />
            ))
          }
          {
            loading && <ProductSkeleton />
          }
        </div>
      </div>
    </>
  )
}
